import PropTypes from 'prop-types'

const HasNotAuthorization = ({ children, hasRole }) => {
    return hasRole ? null : children
}

HasNotAuthorization.propTypes = {
    requiredRole: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ]),
    hasRole: PropTypes.bool,
}

export default HasNotAuthorization



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/HasNotAuthorization.js